import { render, staticRenderFns } from "./lockReason.vue?vue&type=template&id=4536f806&"
import script from "./lockReason.vue?vue&type=script&lang=js&"
export * from "./lockReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports